import {makeAutoObservable, observable} from 'mobx'

interface State {
  modified: number
  companyDepartments: boolean
  companyUsers: boolean
}

export class ApiBlockVisibilityStore {
  state: State = {
    modified: 0,
    companyDepartments: true,
    companyUsers: true
  }

  constructor() {
    makeAutoObservable(this, {state: observable.shallow}, {autoBind: true})
  }

  setVisibility(type: 'company-departments' | 'company-users', value: boolean) {
    if (type === 'company-departments') {
      this.state.companyDepartments = value
    }
    if (type === 'company-users') {
      this.state.companyUsers = value
    }
  }
}

export const apiBlockVisibilityStore = new ApiBlockVisibilityStore()
